import React, {Fragment} from 'react'
import {bool, func, shape, string} from 'prop-types'
import {docTypesData} from '../constants'
import {Grid, LinearProgress, Paper, Typography, withStyles} from 'material-ui'
import CreditCardForm from './CreditCardForm'
import DepositDetails from './DepositDetails'

export const getDocTypeByID = id => docTypesData.find(doc => doc.id === id)

const styles = theme => ({
  completedContainer: {display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%'},
  errorDeposit: {color: 'red'},
  logo: {
    width: '90%',
    maxWidth: 300,
    padding: '40px 0',
    '@media (max-width: 700px)': {
      padding: '20px 0',
    },
  },
  paperContainer: {
    width: '100%',
    maxWidth: 960,
    margin: 'auto',
    marginBottom: 80,
    position: 'relative',
    padding: 30,
    '@media (max-width: 960px)': {
      padding: 15,
    },
  },
  loadingContainer: {height: 5},
})

const Component = ({classes, ...props}) => {
  const {loadingDeposit, errorDeposit, success, completed} = props

  const renderMessage = (message, error = false) => {
    return (
      <div className={classes.completedContainer}>
        <Typography className={error ? classes.errorDeposit : ''}>{message}</Typography>
      </div>
    )
  }

  const renderBody = () => {
    if (errorDeposit) return renderMessage(errorDeposit, true)
    if (completed) return renderMessage('Ya ha completado sus datos. ¡Gracias!')
    if (success) return renderMessage('Ya ha completado sus datos. ¡Gracias!')

    return (
      <Fragment>
        <DepositDetails {...props}/>
        <Grid container item xs={12} justify="center">
          <Paper className={classes.paperContainer}>
            <CreditCardForm {...props}/>
          </Paper>
        </Grid>
      </Fragment>
    )
  }

  return (
    <Grid container spacing={0} justify="center">
      <Grid item xs={12} className={classes.loadingContainer}>
        {loadingDeposit && <LinearProgress/>}
      </Grid>
      <Grid container item xs={12} justify="center" alignItems="center">
        <img className={classes.logo} src="/assets/logo/2.png" alt="Space Guru"/>
      </Grid>
      {!loadingDeposit && renderBody()}
    </Grid>
  )
}

Component.propTypes = {
  loadingDeposit: bool.isRequired,
  loadingCard: bool.isRequired,
  number: string,
  expiry: string,
  cvc: string,
  cardholderName: string,
  documentType: string.isRequired,
  documentNumber: string,
  type: string,
  errorDeposit: string,
  error: string,
  deposit: shape({}).isRequired,
  completed: bool.isRequired,
  success: bool.isRequired,
  getDeposit: func.isRequired,
  setCardNumber: func.isRequired,
  setCardExpiry: func.isRequired,
  setCardCVC: func.isRequired,
  setCardholderName: func.isRequired,
  setDocumentType: func.isRequired,
  setDocumentNumber: func.isRequired,
  setCardType: func.isRequired,
  saveCard: func.isRequired,
}

export default withStyles(styles, {withTheme: true})(Component)



// WEBPACK FOOTER //
// ./src/sections/addCreditCard/components/AddCreditCard.js